export const cacheWaLabel: Record<number, string> = {};
export const cacheDutyLabel: Record<number, string> = {};
